import { formatAdTypeLabels } from '@/components/doohReport/DeliveryDrivers/deliveryDrivers.helpers';
import { getScreenFilterValues } from '../../components/Lists/Screens/screenFilters';
import { firstNumber, GROUP_SEPARATOR, textCell } from './mapper.helpers';

import type { ModifiedScreen } from '../../components/MapView/map.types';
import type { GroupNameResolver, ListExport } from '../export.types';

const HEADERS = [
  'Screen Name',
  'Screen ID',
  'Device ID',
  'Country',
  'Latitude',
  'Longitude',
  'Publisher',
  'Resolution',
  'AdExchange',
  'Venue Type',
  'Creative Format',
  'Group'
];

/** Table of the selected (non deleted) screens, which are keyed by `source_element_id`. Every filter is a column. */
export const buildScreensExport = (
  screens: Partial<ModifiedScreen>[],
  selectedIds: string[],
  groupNames: GroupNameResolver
): ListExport => {
  const selected = new Set(selectedIds);
  const exported = screens.filter(screen => !screen.deleted && selected.has(String(screen.source_element_id)));
  const rows = exported.map(screen => [
    textCell(screen.name),
    String(screen.source_element_id),
    textCell(screen.device_id),
    textCell(screen.geo_country_str),
    firstNumber(screen.latitude, screen.lat),
    firstNumber(screen.longitude, screen.lng),
    textCell(screen.publisher_str),
    textCell(screen.resolution_str),
    textCell(screen.adExchange_str),
    getScreenFilterValues(screen, 'venueType').join(GROUP_SEPARATOR),
    formatAdTypeLabels(getScreenFilterValues(screen, 'creativeFormat')).join(GROUP_SEPARATOR),
    groupNames(screen.groups).join(GROUP_SEPARATOR)
  ]);
  return { excludedCount: 0, table: { headers: HEADERS, rows } };
};
